export default __webpack_public_path__ + "static/media/3-3.88f72ee0.png";